module.exports = __webpack_public_path__ + "img/TechArchImprovedFletching_ua.d471df77.webp";